import React from "react";
import {Chip} from "@mui/material";

/**
 * Универсальный chip-индикатор источника записи (Telegram / MAX).
 * Используется в таблицах диалогов, отзывов и результатов опросов.
 */
export function SourceChip({source}: {source?: string}): JSX.Element {
  switch (source) {
    case 'max':
      return <Chip label="MAX" size="small" color="info" />
    case 'tg':
    case undefined:
      return <Chip label="Telegram" size="small" color="success" />
    default:
      return <Chip label={source} size="small" />
  }
}
